export default __webpack_public_path__ + "images/2a0dd90e0cb9b556257609cddba38bcb.png";